<h1><a routerLink=".." routerLinkActive="_link-active">Chris</a>' GPG key</h1>
<p>Fingerprint: <code>2784A49A280C734C21545A5907C23EF12169858D</code></p>
<p>Entire public key available <a href="/assets/gpg.txt">here</a>.</p>
